import { Grid, makeStyles } from '@material-ui/core'
import { FC } from 'react'

interface StatusProps {
    id: string
    name: string
}
const Status: FC<StatusProps> = ({ id, name }) => {
    const classes = useStyles()

    const chooseClass = (status: string) => {
        switch (status) {
            case '1':
                return classes.waiting
            case '2':
                return classes.approved
            case '3':
                return classes.reject

            default:
                break
        }
    }

    return (
        <Grid container className={chooseClass(id)}>
            <Grid container justify="center" className={classes.container}>
                {name}
            </Grid>
        </Grid>
    )
}

const useStyles = makeStyles(() => ({
    waiting: {
        backgroundColor: '#FCDC4D',
        borderRadius: '24px',
        color: '#CB793A',
    },
    approved: {
        backgroundColor: '#63cc63',
        borderRadius: '24px',
        color: '#0a5f04',
    },
    reject: {
        backgroundColor: '#e06464',
        borderRadius: '24px',
        color: '#8a0404',
    },
    container: {
        padding: '0.7rem',
    },
}))

export default Status
